import React, { useRef } from "react";
import "./About.css";
import useScrollReveal from "../hooks/useScrollReveal.js";
import useSeo, { buildBreadcrumbs } from "../hooks/useSeo.js";

const About = () => {
  const pageRef = useRef(null);
  useScrollReveal(pageRef);
  useSeo({
    title: "About Us – Trusted Carpet & Upholstery Cleaners in Perth",
    description:
      "Learn about Aeti Cleaning Services, a specialised carpet, rug and upholstery restoration provider serving Perth and Western Australia.",
    path: "/about",
    structuredData: buildBreadcrumbs([
      { name: "Home", path: "/" },
      { name: "About Us", path: "/about" },
    ]),
  });

  return (
    <section className="about-section" ref={pageRef}>
      <div className="about-container">
        <div className="about-intro">
          <div>
            <p className="eyebrow reveal">About Us</p>
            <h1 className="about-title reveal" style={{ transitionDelay: "60ms" }}>
              A modern cleaning partner for busy homes and businesses.
            </h1>
            <p className="about-description reveal" style={{ transitionDelay: "120ms" }}>
              Aeti Cleaning Services is proud to offer polished cleaning, upholstery care,
              curtain and window treatments, and convenient laundry support. We combine
              professionalism with a warm, local approach so every visit feels smooth,
              practical and refreshingly reliable.
            </p>
          </div>
          <div className="about-image reveal" style={{ transitionDelay: "80ms" }}>
            <img
              src={require("../assets/residential.jpg")}
              alt="A tidy, freshly cleaned home ready for its next busy week"
            />
          </div>
        </div>

        <div className="about-bio reveal">
          <p className="eyebrow">Corporate overview</p>
          <h2>About Aeti Cleaning Services</h2>
          <p>
            At Aeti, we believe that an interior is more than just a physical space—it holds your
            life, your memories, and your daily comfort. Stains, pet accidents, traffic wear and
            allergens can diminish the beauty and longevity of these valued investments.
          </p>
          <p>
            Aeti Cleaning Services is a premier, specialised restoration provider dedicated to
            reviving carpets, delicate rugs, curtains, mattresses and soft upholstery for homes
            and businesses across Perth and Western Australia. We do not just clean on the
            surface; we perform intensive extraction and fibre treatments that restore texture,
            vibrancy and sanitisation to your home or commercial space.
          </p>
        </div>

        <div className="about-features">
          <div className="feature-card reveal" style={{ transitionDelay: "0ms" }}>
            <h3 className="feature-title">Our expertise</h3>
            <p className="feature-description">
              We specialise in carpet care, rug cleaning, upholstery, mattresses, curtains,
              blinds, windows and laundry services, all designed around the needs of your space.
            </p>
          </div>

          <div className="feature-card reveal" style={{ transitionDelay: "80ms" }}>
            <h3 className="feature-title">Client-first approach</h3>
            <p className="feature-description">
              Transparent pricing, clear communication and a service mindset help us build
              long-lasting relationships with every client we support.
            </p>
          </div>

          <div className="feature-card reveal" style={{ transitionDelay: "160ms" }}>
            <h3 className="feature-title">Trusted service</h3>
            <p className="feature-description">
              Our team is committed to high standards, thoughtful care and dependable results,
              whether you need a one-off refresh or a regular routine.
            </p>
          </div>
        </div>

        <div className="cta-section reveal">
          <h2>Ready for a spotless clean?</h2>
          <p>Book a consultation and let us shape a plan around your home, schedule and budget.</p>
          <a href="/contact" className="cta-button">Contact Us</a>
        </div>
      </div>
    </section>
  );
};

export default About;
